// TODO #1024 add all packages
enum PACKAGES {
  Api = 'escolalms/api',
  AssignWithoutAccount = 'escolalms/assign-without-account',
  Auth = 'escolalms/auth',
  BookmarksNotes = 'escolalms/bookmarks_notes',
  Cart = 'escolalms/cart',
  Categories = 'escolalms/categories',
  Cmi5 = 'escolalms/cmi5',
  CompetencyChallenges = 'escolalms/competency-challenges',
  ConsultationAccess = 'escolalms/consultation-access',
  Consultations = 'escolalms/consultations',
  Core = 'escolalms/core',
  CourseAccess = 'escolalms/course-access',
  Courses = 'escolalms/courses',
  CoursesImportExport = 'escolalms/courses-import-export',
  CsvUsers = 'escolalms/csv-users',
  Files = 'escolalms/files',
  HeadlessH5p = 'escolalms/headless-h5p',
  Images = 'escolalms/images',
  Invoices = 'escolalms/invoices',
  Jitsi = 'escolalms/jitsi',
  Lrs = 'escolalms/lrs',
  Mailerlite = 'escolalms/mailerlite',
  Mattermost = 'escolalms/mattermost',
  ModelFields = 'escolalms/model-fields',
  Notifications = 'escolalms/notifications',
  Pages = 'escolalms/pages',
  Payments = 'escolalms/payments',
  PCGAttendances = 'escolalms/pcg-attendances',
  PCGGrades = 'escolalms/pcg-grades',
  PCGIntegration = 'escolalms/pcg-integration',
  PencilSpaces = 'escolalms/pencil-spaces',
  Permissions = 'escolalms/permissions',
  Questionnaire = 'escolalms/questionnaire',
  Reports = 'escolalms/reports',
  Scorm = 'escolalms/scorm',
  Settings = 'escolalms/settings',
  StationaryEvents = 'escolalms/stationary-events',
  Tags = 'escolalms/tags',
  Tasks = 'escolalms/tasks',
  Templates = 'escolalms/templates',
  TemplatesEmail = 'escolalms/templates-email',
  TemplatesPdf = 'escolalms/templates-pdf',
  TemplatesSms = 'escolalms/templates-sms',
  TopicTypeGift = 'escolalms/topic-type-gift',
  TopicTypeProject = 'escolalms/topic-type-project',
  TopicTypes = 'escolalms/topic-types',
  Tracker = 'escolalms/tracker',
  Translations = 'escolalms/translations',
  Video = 'escolalms/video',
  Vouchers = 'escolalms/vouchers',
  Webinar = 'escolalms/webinar',
  Youtube = 'escolalms/youtube',
  Recommender = 'escolalms/recommender',
  Dictionary = 'escolalms/dictionaries',
  RevenuecatIntegration = 'escolalms/revenuecat-integration',
}

export default PACKAGES;
